// Added for convenience in the Node environment.
// The meat and potatoes exist in ./lib/polyglot.js.
module.exports = require('./lib/polyglot');



//////////////////
// WEBPACK FOOTER
// ./~/node-polyglot/index.js
// module id = 947
// module chunks = 0